import { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { brancherAuth } from './api/http';
import { nombreEnAttente, surChangementFile, synchroniser } from './offline/syncManager';
import ConnexionScreen from './screens/ConnexionScreen';
import ListeScreen from './screens/ListeScreen';
import SaisieScreen from './screens/SaisieScreen';
import SyncScreen from './screens/SyncScreen';

// Machine à écrans : connexion -> liste (drill-down, dépend du/des rôle(s) du compte) -> saisie
// des mesures. L'écran de synchronisation est un aparté accessible depuis le badge permanent de
// la saisie, et y ramène en le refermant.
function AppInterieur() {
  const auth = useAuth();
  const [ecran, setEcran] = useState('liste');
  const [session, setSession] = useState(null); // { id, contexte }
  const [ecranAvantSync, setEcranAvantSync] = useState('saisie');

  const [enLigne, setEnLigne] = useState(navigator.onLine);
  const [enAttenteGlobal, setEnAttenteGlobal] = useState(0);

  // Le client HTTP ne connaît pas React : on lui fournit les accesseurs de jetons une fois le
  // contexte d'auth disponible, et à chaque changement (nouveau login, refresh).
  useEffect(() => {
    brancherAuth({ getAccessToken: auth.getAccessToken, forcerRefresh: auth.forcerRefresh });
  }, [auth.getAccessToken, auth.forcerRefresh]);

  useEffect(() => {
    function surLigne() { setEnLigne(true); synchroniser(); }
    function horsLigne() { setEnLigne(false); }
    window.addEventListener('online', surLigne);
    window.addEventListener('offline', horsLigne);
    return () => {
      window.removeEventListener('online', surLigne);
      window.removeEventListener('offline', horsLigne);
    };
  }, []);

  useEffect(() => {
    function rafraichir() { nombreEnAttente().then(setEnAttenteGlobal); }
    rafraichir();
    return surChangementFile(rafraichir);
  }, []);

  if (!auth.pretAuthentifie) {
    return null; // vérification silencieuse d'une session persistée, avant d'afficher quoi que ce soit
  }

  if (!auth.connecte) {
    return <ConnexionScreen onConnecter={auth.login} erreur={auth.erreurAuth} enLigne={enLigne} />;
  }

  if (ecran === 'sync') {
    return <SyncScreen enLigne={enLigne} onFermer={() => setEcran(ecranAvantSync)} />;
  }

  if (ecran === 'saisie' && session) {
    return (
      <SaisieScreen
        sessionId={session.id}
        contexteInitial={session.contexte}
        enLigne={enLigne}
        onRetour={() => { setSession(null); setEcran('liste'); }}
        onOuvrirSync={() => { setEcranAvantSync('saisie'); setEcran('sync'); }}
      />
    );
  }

  return (
    <ListeScreen
      roles={auth.roles}
      nomAffiche={auth.nomAffiche}
      onLogout={auth.logout}
      enLigne={enLigne}
      enAttente={enAttenteGlobal}
      onOuvrirSession={(sessionId, contexte) => {
        setSession({ id: sessionId, contexte });
        setEcran('saisie');
      }}
    />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInterieur />
    </AuthProvider>
  );
}
